import { render } from "./RecomendacionesForm.vue?vue&type=template&id=187f47d3"
import script from "./RecomendacionesForm.vue?vue&type=script&lang=js"
export * from "./RecomendacionesForm.vue?vue&type=script&lang=js"

import exportComponent from "/www/wwwroot/plus.centrodeglaucoma.com/darmin-plus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__